import ManagerIntelligenceWhitepaper from "./ManagerIntelligenceWhitepaper";

export { Page }

function Page() {
  return <ManagerIntelligenceWhitepaper />;
}
